import { useState } from "react";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

import { useUserData } from "src/context/userContext";
import { useAttachmentsData } from "src/context/AttachmentsContext";

import {
  attachment_attachToKeikka,
  attachment_delete,
} from "src/components/attachments/AttachmentFunctions";
import { CancelIcon, DeleteIcon } from "src/components/icons/ActionIcons";
import AreYouSureButton from "src/components/buttons/AreYouSureButton/AreYouSureButton";
import { AttachmentIcon, DeAttachIcon } from "src/components/icons/NavIcons";
import { PdfIcon } from "src/components/icons/MediaIcons";

const AttachmentListItem = ({ attachment, deAttachOnDelete = false, allowDelete = false }) => {
  const { token } = useUserData();
  const { setAttachmentList, setSelectedAttachment } = useAttachmentsData();
  const [loading, setLoading] = useState(false);

  const handleImageClick = () => setSelectedAttachment(attachment);

  const handleDeleteClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!deAttachOnDelete) return await handleDelete();
    else return await handleDeAttach();
  };

  const handleDeAttach = async () => {
    setLoading(true);
    const result = await attachment_attachToKeikka(attachment.attachmentId, null, token);
    console.log(result);
    setAttachmentList((prevList) =>
      prevList.filter((i) => i.attachmentId !== attachment.attachmentId)
    );
    setLoading(false);
    return true;
  };

  const handleDelete = async () => {
    setLoading(true);
    const result = await attachment_delete(attachment.attachmentId, token);
    if (result.ok === false && result.error !== "BlobNotFound") {
      setLoading(false);
      return false;
    }
    setAttachmentList((prevList) =>
      prevList.filter((i) => i.attachmentId !== attachment.attachmentId)
    );
    setLoading(false);
    return true;
  };

  return (
    <ListItem key={attachment.attachmentId} disablePadding>
      <ListItemButton onClick={handleImageClick}>
        <ListItemIcon>
          {attachment.origFileName.endsWith(".pdf") ? <PdfIcon /> : <AttachmentIcon />}
        </ListItemIcon>
        <ListItemText primary={attachment.origFileName} secondary={attachment.fileComment} />
      </ListItemButton>
      {allowDelete && (
        <AreYouSureButton
          component="iconButton"
          onClick={handleDeleteClick}
          snackbarProps={{
            title: deAttachOnDelete ? "Liitteen irrotus" : "Liitteen poisto",
            failMessage: deAttachOnDelete
              ? "Liite irrotettu tilauksesta"
              : "Liitteen poisto epäonnistui.",
            doneMessage: deAttachOnDelete ? "Liite irrotettu" : "Liite poistettu.",
            autoHideDuration: 2000,
          }}
          toolTipProps={{
            title: deAttachOnDelete ? "Irrota liite tilauksesta" : "Poista liite pysyvästi",
            placement: "right",
          }}
          disabled={loading}
          isLoading={loading}
          askAreYouSure={true}
          dontAskId={deAttachOnDelete ? "irrotaLiite" : "poistaLiite"}
          dialogProps={{
            title: deAttachOnDelete ? "Liitteen irrotus" : "Liitteen poisto",
            content: deAttachOnDelete
              ? "Irrota '" +
                attachment.origFileName +
                "' tästä tilauksesta. Liite siirtyy käsittelemättömiin."
              : "Tämä poistaa liitteen pysyvästi.",
            acceptText: deAttachOnDelete ? "IRROTA LIITE" : "POISTA LIITE",
            cancelText: "PERUUTA",
            ConfirmIcon: <DeleteIcon />,
            CancelIcon: <CancelIcon color="error" />,
          }}>
          {deAttachOnDelete ? <DeAttachIcon /> : <DeleteIcon />}
        </AreYouSureButton>
      )}
    </ListItem>
  );
};

export default AttachmentListItem;

AttachmentListItem.propTypes = {
  attachment: PropTypes.object,
  deAttachOnDelete: PropTypes.bool,
  allowDelete: PropTypes.bool,
};
